import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export var FORCE_QUERY_KEY = 'force-exp-';
export var forcedExperimentParams = function forcedExperimentParams() {
  if (typeof window === 'undefined') {
    return null;
  }
  var searchEntries = new URLSearchParams(window.location.search).entries();
  var forceQueryEntries = Array.from(searchEntries).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      _ = _ref2[1];
    return key.startsWith(FORCE_QUERY_KEY);
  });
  return forceQueryEntries.length ? Object.fromEntries(forceQueryEntries) : null;
};